import React from 'react';
import { HuchaValues } from '../models/hucha-values';
import { useTrackingManager } from '../../../../tracking/useTrackingManager';
import { PortalContext } from '../../../../context/PortalContext';
import { formatOwnership } from '../../../../tracking/trackingHelper';
import { FocusLayerSizeV2, ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';
import { HuchaPopupContent } from '../components/popup/hucha-popup-content';

// hook para manejar el popup/layer de la hucha
export const useHuchaPopup = (huchaValues: HuchaValues | null) => {
	const portalContext = React.useContext(PortalContext);
	const { portalService, layerManager } = portalContext;

	const trackingManager = useTrackingManager();
	const userVehicles = portalService.getPersonVehicles().getValue();

	const [isPopupVisible, setIsPopupVisible] = React.useState(false);
	const layerRef = React.useRef<any>(null);

	const discountType = huchaValues?.isRenovador ? 'Mi Hucha + Renovadores 1015 Volkswagen' : 'Mi Hucha';

	const handlePopupOpen = () => {
		trackingManager.trackClubVWButtonClick(
			`${discountType}`,
			{ contentId: `Open ${discountType} Layer` },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
		setIsPopupVisible(true);
	};

	React.useEffect(() => {
		if (userVehicles && isPopupVisible) {
			trackingManager.trackClubVWLayerLoad(
				{ contentId: 'Hucha Bonus' },
				{ vehicle: formatOwnership(userVehicles.vehicles) },
			);
		}
	}, [userVehicles, isPopupVisible]);

	const handlePopupClose = () => {
		setIsPopupVisible(false);
		trackingManager.trackClubVWLayerCloseClick(`${discountType}`, { contentId: `Close ${discountType} Layer` });
	};

	React.useEffect(() => {
		if (!isPopupVisible) return;

		const layer = layerManager.openFocusLayer(
			() => (
				<HuchaPopupContent
					huchaValues={huchaValues}
					portalContext={portalContext}
					handlePopupClose={handlePopupClose}
				/>
			),
			{},
			{
				size: FocusLayerSizeV2.A,
				shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
			},
		);

		layerRef.current = layer;

		return () => {
			layer.close();
			layerRef.current = null;
		};
	}, [isPopupVisible, huchaValues, portalContext, layerManager]);

	return {
		isPopupVisible,
		handlePopupOpen,
		handlePopupClose,
	};
};
